if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
        this.addEventListener('keydown', this.onKeydown.bind(this));
        // Theme editor: open the tab whose block is selected in the sidebar.
        this.addEventListener('shopify:block:select', (event) => this.select(event.target));
      }

      select(tab) {
        if (!this.tabs.includes(tab)) return;

        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected);
          item.tabIndex = selected ? 0 : -1;
          document.getElementById(item.getAttribute('aria-controls')).hidden = !selected;
        });
      }

      onKeydown(event) {
        const index = this.tabs.indexOf(event.target);
        if (index === -1) return;

        const last = this.tabs.length - 1;
        const next = {
          ArrowRight: index === last ? 0 : index + 1,
          ArrowLeft: index === 0 ? last : index - 1,
          Home: 0,
          End: last,
        }[event.key];
        if (next === undefined) return;

        event.preventDefault();
        this.tabs[next].focus();
        this.select(this.tabs[next]);
      }
    }
  );
}
